import router from '@/router'
import { useUserStore } from '@/stores/user'
import { loadScript, tokenWhite } from '@/utils'
import { getUrlParms } from '@/utils/index'

let isLoadLayaLogin = false

router.beforeEach(async (to, from) => {
  if (!isLoadLayaLogin) {
    await loadScript("https://layamarket.layabox.com/SDK/layaSdk.js?v=1")
    isLoadLayaLogin = true
  }

  const userStore = useUserStore()
  const isLogin = userStore.checkLogin()
  let url = new URL(window.location.href)
  let urlToken = url.searchParams.get("token") || getUrlParms("token")
  // 检查是否在白名单中
  const isInTokenWhite = tokenWhite.includes(to.path)

  if (!isLogin) {
    if (isInTokenWhite) {
      if (urlToken) {
        await userStore.login()
      }
    } else {
      let loginRes = await userStore.login()
      if (!loginRes) {
        // 登录失败，重定向到首页
        return { path: '/' }
      }
    }
  }
  // 继续导航
  return true
})


